import styled from 'styled-components';
import { Text } from '../../../../../components/ToolkitV2/Text/Text';

const NewText = styled(Text)`
  display: flex;
  border: 1px solid ${({ theme }) => theme.colors.GREY};
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  padding: 1px ${({ theme }) => theme.spacing.S4};
`;

const IconTitle = styled(Text)`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.S8};
`;
export { NewText, IconTitle };
